// @flow

import { getCountry, getWithholdTaxes } from '@tectonics/prs/incoming-payment';
import { isLocalLatamTenantCode, isDiamondTenantCode } from '@tectonics/commons/tenant';
import { type IncomingPayment } from './types';

export function shouldHideInstructionTextCertificateWithholdTaxesByCustomer(
  incomingPayment: IncomingPayment,
  localTenancy: string,
): boolean {
  const country = getCountry(incomingPayment);
  const withholdTaxes = getWithholdTaxes(incomingPayment);

  const shouldHideInstructionTextCertificate = country !== 'ar' || withholdTaxes !== 'not_withhold_taxes';
  const isNotCrossBorderTenantCode = isLocalLatamTenantCode(localTenancy) || isDiamondTenantCode(localTenancy);

  return shouldHideInstructionTextCertificate || isNotCrossBorderTenantCode;
}
